<script lang="ts">
    import { _ } from "svelte-i18n"
    import { navigate } from "../../../../../vendor/svelte-routing"
    import CheckoutFooter from "./CheckoutFooter.svelte"
    import FormInputText from "../../widgets/FormInputText.svelte"
    import { cart, checkoutData, login } from "../../../store"
    import ShippingDeliveryAddress from "./ShippingDeliveryAddress.svelte"
    import { max } from "lodash"
    import { maxInputLength } from "../../../../../api/hooks/config-client"

    const invalidate = () => {
        $checkoutData.stepsValid = 0
    }

    $: {
        if (!$cart?.length || $login) {
            // empty cart goto start
            navigate("/", { replace: true })
        }
    }
</script>

<div class="subline">{$_("checkout.order")}</div>
<h2 class="h2_nooffset">{$_("checkout.info-and-shipping")}</h2>

<form
    on:submit|preventDefault="{() => {
        $checkoutData.stepsValid = 1
        navigate('/checkout/payment')
    }}"
>
    <section>
        <div class="section_headline">{$_("checkout.contact-info")}</div>
        <div class="row">
            <div class="col-md-12">
                <FormInputText
                    name="email"
                    placeholder="{$_('checkout.email')}"
                    bind:value="{$checkoutData.contact.email}"
                    type="email"
                    required
                    on:change="{invalidate}"
                    maxlength="{maxInputLength.email}"
                />
            </div>
            <div class="col-md-12">
                <FormInputText
                    name="phone"
                    placeholder="{$_('checkout.phone')}"
                    tooltip="{$_('inquiry.phone-tooltip')}"
                    bind:value="{$checkoutData.contact.phone}"
                    type="tel"
                    required
                    on:change="{invalidate}"
                    maxlength="{maxInputLength.phone}"
                />
            </div>
        </div>
    </section>

    <ShippingDeliveryAddress />

    <CheckoutFooter
        backlink="/"
        backtitle="{$_('checkout.back-to-shop')}"
        nexttitle="{$_('checkout.proceed-to-payment')}"
    />
</form>
